import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

let toasts = $.state($.proxy([]));

export function showToast(message, type = 'info') {
	const id = crypto.randomUUID();

	$.set(toasts, [...$.get(toasts), { id, message, type }], true);

	setTimeout(
		() => {
			$.set(toasts, $.get(toasts).filter((t) => t.id !== id), true);
		},
		3000
	);
}

var root_2 = $.from_html(`<div> </div>`);
var root_1 = $.from_html(`<div class="toast-container svelte-203phb7254zfb"></div>`);

function Toast($$anchor) {
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root_1();

			$.each(div, 21, () => $.get(toasts), (toast) => toast.id, ($$anchor, toast) => {
				var div_1 = root_2();
				var text = $.child(div_1, true);

				$.reset(div_1);

				$.template_effect(() => {
					$.set_class(div_1, 1, `toast toast-${$.get(toast).type ?? ''}`, 'svelte-203phb7254zfb');
					$.set_text(text, $.get(toast).message);
				});

				$.append($$anchor, div_1);
			});

			$.reset(div);
			$.append($$anchor, div);
		};

		$.if(node, ($$render) => {
			if ($.get(toasts).length > 0) $$render(consequent);
		});
	}

	$.append($$anchor, fragment);
}

if (import.meta.hot) {
	Toast = $.hmr(Toast);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-203phb7254zfb');
		Toast[$.HMR].update(module.default);
	});
}

export default Toast;
import "bun-svelte:Toast.svelte-2v4z4hk20w1g2-style.css";